import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import FenceDecisionTool from './DecisionTools/FenceDecisionTool';
import modelAPI from '../../../api/model';
import { getString } from '../../../helpers/stringHelpers.js';

const stringsComponent = 'fencingApplications';

class ApplicationChildCard extends React.Component {
  handleSubmit(responses) {
    const { customerName, contactData, tenancyData } = this.props;

    const data = {
      customerName: customerName,
      customerEmail: contactData.email,
      customerAddress: tenancyData.currentTenancy.propertyAddress,
      customerMobile: contactData.mobilePhone,
      responses: responses,
    };

    modelAPI.addApplication(data);
  }

  render() {
    const { classes, slug, goDash } = this.props;

    return (
      <div className={`${classes.root} PageLayout`}>
        <Grid container spacing={24} className="DashGridContainer">
          <Grid item xs={12} className="DashGridColumn">
            {slug === 'Fences' && (
              <FenceDecisionTool
                title={getString(stringsComponent, 'CARD_TITLE')}
                handleSubmit={(data) => this.handleSubmit(data)}
                handleClose={goDash}
              />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

ApplicationChildCard.propTypes = {
  classes: PropTypes.object.isRequired,
  goDash: PropTypes.func.isRequired,
  tenancyData: PropTypes.object.isRequired,
  contactData: PropTypes.object.isRequired,
  customerName: PropTypes.string.isRequired,
};

export default withStyles(styles)(ApplicationChildCard);
